import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navigation-drawer__drawer-content-wrapper" }
const _hoisted_2 = { class: "navigation-drawer__drawer-upper-content" }
const _hoisted_3 = { class: "navigation-drawer__close-menu-wrapper" }
const _hoisted_4 = { class: "navigation-drawer__navigation-drawer-link-wrapper" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "header__link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    class: "navigation-drawer",
    width: 240,
    location: "right",
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpen) = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              class: "navigation-drawer__close-icon",
              icon: "$close",
              size: "24",
              onClick: _withModifiers(_ctx.toggleOpenMenu, ["stop"])
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NAVIGATION_LINKS, (link, index) => {
              return (_openBlock(), _createElementBlock("a", {
                key: index,
                href: link.href,
                class: "navigation-drawer__nav-button",
                target: "_blank"
              }, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(link.title), 1)
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "navigation-drawer__drawer-lower-content" }, [
          _createElementVNode("div", { class: "navigation-drawer__copyright-wrapper" }, [
            _createElementVNode("span", { class: "navigation-drawer__copyright" }, "© Art Mindfully 2025")
          ])
        ], -1))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}